import axios from 'axios'

import { asyncTimeout } from 'js/helpers/utils'
import { IsDev } from 'js/helpers/build'
import postBasket from 'js/components/shared/actions/postBasket'

import { FILTER_APPLY } from '../constants'
import updateRemovedRooms from './updateRemovedRooms'
import filterChange from './filterChange'

const removeUrl = window?.drupalSettings?.rooms?.removeUrl;

const deleteHandler = async (dispatch, rooms) => {
  dispatch(updateRemovedRooms(''))
  dispatch(filterChange('rooms', rooms.filter(r => r.visible === true)))
  await dispatch(postBasket({ getBasket: true }))
}

export default (filterType, doApply, applyOnSubmit) => async (dispatch, getState) => {
  const state = getState()
  const { form: { searchFilters: { removedRooms, rooms } } } = state

  if (applyOnSubmit) {
    // TODO: check "remove rooms" logic. Probably currently fully deprecated and should be removed.
    if (removeUrl && removeUrl.length && removedRooms.length) {
      if (IsDev) {
        console.info(`%c DELETE /api/booking/room/remove/${removedRooms}`, 'color: #67a9ad; font-weight: bold;')
        await asyncTimeout(1)
        await deleteHandler(dispatch, rooms)
      } else {
        await axios.delete(`${removeUrl}/${removedRooms}`)
        await deleteHandler(dispatch, rooms)
      }
    } else {
      dispatch(filterChange('rooms', rooms.filter(r => r.visible === true)))
    }
  }

  dispatch({
    type: FILTER_APPLY,
    filterType,
    doApply,
  })
}
